
    import I18n from 'i18nObj';
    
      import 'translations/assignments.delete_group';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('assignments.delete_group');
  